var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-col",
        [
          _c(
            "b-row",
            [
              _c(
                "b-form-group",
                {
                  staticClass: "w-100",
                  attrs: {
                    id: "country-group",
                    label: _vm.$t("xCountry"),
                    "label-for": "country"
                  }
                },
                [
                  _c("b-form-select", {
                    attrs: {
                      id: "country",
                      options: [
                        {
                          text: _vm.$t("xSelect"),
                          value: null,
                          disabled: true
                        },
                        ..._vm.countryOptions
                      ],
                      state: _vm.validState(_vm.$v.formSelections.country),
                      "aria-describedby": "country-invalid"
                    },
                    on: {
                      change: function($event) {
                        return _vm.setStateOptions()
                      }
                    },
                    model: {
                      value: _vm.$v.formSelections.country.$model,
                      callback: function($$v) {
                        _vm.$set(_vm.$v.formSelections.country, "$model", $$v)
                      },
                      expression: "$v.formSelections.country.$model"
                    }
                  }),
                  _c(
                    "b-form-invalid-feedback",
                    { attrs: { id: "country-invalid" } },
                    [_vm._v(" " + _vm._s(_vm.$t("xErrorCountryEmpty")) + " ")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "b-row",
            [
              _c(
                "b-form-group",
                {
                  staticClass: "w-100",
                  attrs: {
                    id: "line1-group",
                    label: _vm.$t("xAddress"),
                    "label-for": "line1"
                  }
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "line1",
                      state: _vm.validState(_vm.$v.formSelections.address1),
                      maxlength: "50",
                      type: "text",
                      "aria-describedby": "line1-invalid"
                    },
                    model: {
                      value: _vm.$v.formSelections.address1.$model,
                      callback: function($$v) {
                        _vm.$set(_vm.$v.formSelections.address1, "$model", $$v)
                      },
                      expression: "$v.formSelections.address1.$model"
                    }
                  }),
                  _c(
                    "b-form-invalid-feedback",
                    { attrs: { id: "line1-invalid" } },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.getErrorMessageForField("address1")) +
                          " "
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "b-row",
            [
              _c(
                "b-form-group",
                {
                  staticClass: "w-100",
                  attrs: {
                    id: "line2-group",
                    label: _vm.$t("xAddressLine2Optional"),
                    "label-for": "line2"
                  }
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "line2",
                      state: _vm.validState(_vm.$v.formSelections.address2),
                      type: "text",
                      maxLength: "50",
                      "aria-describedby": "line2-invalid"
                    },
                    model: {
                      value: _vm.$v.formSelections.address2.$model,
                      callback: function($$v) {
                        _vm.$set(_vm.$v.formSelections.address2, "$model", $$v)
                      },
                      expression: "$v.formSelections.address2.$model"
                    }
                  }),
                  _c(
                    "b-form-invalid-feedback",
                    { attrs: { id: "line2-invalid" } },
                    [_vm._v(_vm._s(_vm.$t("xErrorAddressInvalid")))]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "b-row",
            [
              _c(
                "b-form-group",
                {
                  staticClass: "w-100",
                  attrs: {
                    id: "city-group",
                    label: _vm.$t("xCity"),
                    "label-for": "city"
                  }
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "city",
                      maxLength: "50",
                      state: _vm.validState(_vm.$v.formSelections.city),
                      "aria-labelledby": "city-invalid"
                    },
                    model: {
                      value: _vm.$v.formSelections.city.$model,
                      callback: function($$v) {
                        _vm.$set(_vm.$v.formSelections.city, "$model", $$v)
                      },
                      expression: "$v.formSelections.city.$model"
                    }
                  }),
                  _c(
                    "b-form-invalid-feedback",
                    { attrs: { id: "city-invalid" } },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.getErrorMessageForField("city")) + " "
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "b-row",
            [
              _c(
                "b-form-group",
                {
                  staticClass: "w-100",
                  attrs: {
                    id: "state-group",
                    label: _vm.$t("xStateRegion"),
                    "label-for": "state"
                  }
                },
                [
                  _c("b-form-select", {
                    attrs: {
                      id: "state",
                      state: _vm.validState(_vm.$v.formSelections.state),
                      options: [
                        {
                          text: _vm.$t("xSelect"),
                          value: null,
                          disabled: true
                        },
                        ..._vm.stateOptions
                      ],
                      "aria-describedby": "state-invalid"
                    },
                    model: {
                      value: _vm.$v.formSelections.state.$model,
                      callback: function($$v) {
                        _vm.$set(_vm.$v.formSelections.state, "$model", $$v)
                      },
                      expression: "$v.formSelections.state.$model"
                    }
                  }),
                  _c(
                    "b-form-invalid-feedback",
                    { attrs: { id: "state-invalid" } },
                    [_vm._v(" " + _vm._s(_vm.$t("xErrorRegionEmpty")) + " ")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "b-row",
            [
              _c(
                "b-form-group",
                {
                  staticClass: "w-100",
                  attrs: {
                    id: "postalCode-group",
                    label: _vm.$t("xPostalCode"),
                    "label-for": "postalCode"
                  }
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "postalCode",
                      type: "text",
                      maxlength: "10",
                      state: _vm.validState(_vm.$v.formSelections.postalCode),
                      debounce: "500",
                      "aria-describedby": "postalCode-invalid"
                    },
                    model: {
                      value: _vm.$v.formSelections.postalCode.$model,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.$v.formSelections.postalCode,
                          "$model",
                          $$v
                        )
                      },
                      expression: "$v.formSelections.postalCode.$model"
                    }
                  }),
                  _c(
                    "b-form-invalid-feedback",
                    { attrs: { id: "postalCode-invalid" } },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.getErrorMessageForField("postalCode")) +
                          " "
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }